var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 4.33333C10.833 5.622 9.78829 6.66667 8.49963 6.66667C7.21097 6.66667 6.1663 5.622 6.1663 4.33333C6.1663 3.04467 7.21097 2 8.49963 2C9.78829 2 10.833 3.04467 10.833 4.33333Z",
    stroke: "#9C9C9C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11572 11.6599C4.34425 10.0765 5.57007 8.78259 7.16562 8.66635C8.07723 8.59994 8.9252 8.59983 9.83507 8.66599C11.43 8.78196 12.6549 10.0758 12.8833 11.6585L12.9278 11.9663C13.0594 12.8785 12.4257 13.73 11.5093 13.8282C9.3586 14.0589 7.6477 14.0562 5.49377 13.8265C4.57593 13.7286 3.94013 12.8764 4.072 11.9628L4.11572 11.6599Z",
    stroke: "#9C9C9C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.6638642c64ad3f4b7e3dc8e556b45454.svg";
export { ForwardRef as ReactComponent };